import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { RespondConfirmation } from '../objects/DialogObject'
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';


@Injectable({
  providedIn: 'root'
})
export class ConfirmationService {

  bsModalRef: BsModalRef;

  constructor(
    private bsModalService: BsModalService,
    private respondConfirmation : RespondConfirmation
  ) { }

  confirm(title: string, message: string, options: string[], input: boolean = false, inputPlaceholder: string="", enableSpeech: boolean=false, validateInput: string="", manualHide:boolean = false, positiveButtonColor: string = ""): Observable<RespondConfirmation> {
    const initialState = {
      title: title,
      message: message,
      options: options,
      answer: "",
      input: input,
      inputPlaceholder,
      enableSpeech,
      validateInput,
      manualHide,
      positiveButtonColor
    };

    // if (this.bsModalService.getModalsCount() > 0){
    //   document.querySelectorAll('.modal.fade').item(this.bsModalService.getModalsCount() - 1).classList.remove('show');
    // }

    this.bsModalRef = this.bsModalService.show(ConfirmationDialogComponent, { class: "modal-dialog-centered modal-confirm", ignoreBackdropClick: true, keyboard: false, initialState });

    document.querySelectorAll('.modal').item(this.bsModalService.getModalsCount() - 1).classList.add('confirm');
    if (document.querySelectorAll('.modal-backdrop').item(0) && this.bsModalService.getModalsCount() > 1){
      document.querySelectorAll('.modal-backdrop').item(0).classList.add('dark');
    }

    return new Observable<RespondConfirmation>(this.getConfirmSubscriber());
  }

  confirmNoInput(title: string, message: string, options: string[]): Observable<RespondConfirmation> {
    const initialState = {
      title: title,
      message: message,
      options: options,
      answer: ""
    };

    // if (this.bsModalService.getModalsCount() > 0){
    //   document.querySelectorAll('.modal.fade').item(this.bsModalService.getModalsCount() - 1).classList.remove('show');
    // }
    //document.querySelectorAll('.modal-backdrop').item(0).classList.add('dark');

    this.bsModalRef = this.bsModalService.show(ConfirmationDialogComponent, { class: "modal-dialog-centered modal-confirm", ignoreBackdropClick: true, keyboard: false, initialState });

    document.querySelectorAll('.modal').item(this.bsModalService.getModalsCount() - 1).classList.add('confirm');
    if (document.querySelectorAll('.modal-backdrop').item(0) && this.bsModalService.getModalsCount() > 1){
      document.querySelectorAll('.modal-backdrop').item(0).classList.add('dark');
    }

    return new Observable<RespondConfirmation>(this.getConfirmSubscriber());
  }

  confirmTimeout(title: string, message: string, timeout: number, options: string[]): Observable<RespondConfirmation> {
    const initialState = {
      title: title,
      message: message,
      timeout: timeout,
      options: options,
      answer: ""
    }

    if (this.bsModalService.getModalsCount() > 0){
      document.querySelectorAll('.modal.fade').item(this.bsModalService.getModalsCount() - 1).classList.remove('show');
    }

    this.bsModalRef = this.bsModalService.show(ConfirmationDialogComponent, { class: "modal-dialog-centered modal-confirm", ignoreBackdropClick: true, keyboard: false, initialState });

    return new Observable<RespondConfirmation>(this.getConfirmSubscriber());
  }

  private getConfirmSubscriber() {
    return (observer) => {
      const subscription = this.bsModalService.onHidden.subscribe((reason: string) => {
        if (document.querySelectorAll('.modal-backdrop').item(0)){
          document.querySelectorAll('.modal-backdrop').item(0).classList.remove('layer');
          document.querySelectorAll('.modal-backdrop').item(0).classList.remove('dark');
        }
        if (this.bsModalService.getModalsCount() > 0){
          document.querySelectorAll('.modal.fade').item(this.bsModalService.getModalsCount() - 1).classList.add('show');
        }

        this.respondConfirmation.inputText = this.bsModalRef.content.inputText;
        this.respondConfirmation.answer = this.bsModalRef.content.answer;
        observer.next(this.respondConfirmation);
        observer.complete();
      });

      return {
        unsubscribe() {
          subscription.unsubscribe();
        }
      };
    }
  }

}


